import React from 'react';

import { fakeLink } from 'src/components/molecules/AddressSearch/styles/styles';

export type FakeLinkProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLParagraphElement>,
  HTMLParagraphElement
>;

export const FakeLink = (props: FakeLinkProps) => (
  <p css={fakeLink} {...props}>
    {props.children}
  </p>
);
